import { useCallback, useMemo, useState } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';

const RESET_LABEL_TIMER = 3000;

type ShareData = { clickedState: boolean; buttonLabel: TranslationKey };
type ShareActions = { afterShare: () => void };
type UseDefaultShareButtonResult = ModelHookResult<ShareData, ShareActions>;
type UseShareButtonArgs = {
	label: TranslationKey;
	successLabel?: TranslationKey;
};
export function useShareButton({ label, successLabel }: UseShareButtonArgs): UseDefaultShareButtonResult {
	const [clickedState, setClickedState] = useState(false);

	const afterShare = useCallback(() => {
		if (successLabel) {
			setClickedState(true);
			// Timeout to reset the style
			window.setTimeout(() => {
				setClickedState(false);
			}, RESET_LABEL_TIMER);
		}
	}, [setClickedState, successLabel]);

	const buttonLabel = useMemo(
		() => (successLabel && clickedState ? successLabel : label),
		[clickedState, successLabel, label],
	);

	return {
		data: { clickedState, buttonLabel },
		actions: { afterShare },
	};
}
